export default __webpack_public_path__ + "static/media/car.1375f0f6.png";